import { module } from 'modujs';
import Swiper, { Navigation } from 'swiper';

const BREAKPOINTS = {
    SMALL: 700,
    MEDIUM: 1000
}

export default class extends module {
    constructor(m) {
        super(m)

        // UI
        this.$el = this.el
        this.$container = this.$('container')[0]
        this.$arrowNext = this.$('next')[0]
        this.$arrowPrev = this.$('prev')[0]

        // Data
        this.mobileOnly = this.getData('size') == 'mobile'
        this.desktopOnly = this.getData('size') == 'desktop'
        this.centeredSlides = this.getData('align') == 'center' ? true : false
        this.initialSlide = this.getData('start') ? this.getData('start') : 0
        this.length = this.$('item').length
        this.id = this.getData('id')
        this.carousel = null
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        if (this.mobileOnly  && window.innerWidth > BREAKPOINTS.SMALL) return
        if (this.desktopOnly && window.innerWidth < BREAKPOINTS.SMALL) return

        Swiper.use([ Navigation ])

        const args = {
            spaceBetween: 0,
            slidesPerView: 'auto',
            allowTouchMove: window.isMobile,
            centeredSlides: this.centeredSlides,
            initialSlide: this.initialSlide,
            navigation: {
                prevEl: this.$arrowPrev,
                nextEl: this.$arrowNext
            }
        }

        if (this.length > 1) {
            this.carousel = new Swiper(this.$container, args)
            this.call('update', null, 'Scroll')
        } else {
            this.$el.classList.add('has-one-slide')
        }
    }

    destroy() {
        super.destroy()
        this.carousel?.destroy(true, true)
    }
}
